import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import axios from "axios";
import { ApiHost } from "../../API";


type Section = {
  id: number;
  title: string;
  page_id: number;
  video_url: string | null;
  image_url: string | null;
  section_name: string;
};

type Feature = {
  id: number;
  name: string;
  image_url: string;
  section_id: number;
  description: string | null;
};

type SectionData = {
  section: Section;
  features: Feature[];
};

type SectionsContextType = {
  sections: SectionData[];
  loading: boolean;
  error: string | null;
};


const SectionsContext = createContext<SectionsContextType | undefined>(undefined);


export const SectionsProvider = ({ children }: { children: ReactNode }) => {
  const [sections, setSections] = useState<SectionData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await axios.get(`${ApiHost}/api/Section/with-features`);
        setSections(response.data);
      } catch (err) {
        setError("حدث خطأ أثناء جلب البيانات");
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, []);

  return (
    <SectionsContext.Provider value={{ sections, loading, error }}>
      {children}
    </SectionsContext.Provider>
  );
};


export const useSections = () => {
  const context = useContext(SectionsContext);
  if (!context) throw new Error("useSections يجب أن يكون داخل SectionsProvider");
  return context;
};
